import { cn } from '@pesto/utils';
import React from 'react';
import { Link } from 'react-router-dom';

import type { NavigationLinkProps } from './Navigation.types';

export const NavigationLink: React.FC<NavigationLinkProps> = (props) => {
  const { label, href, current = false, icon, className, minimized, isSub, onClick } = props;
  const Icon = icon;

  const style = cn(
    'hover:bg-sidebar-text-selected/10 hover:text-sidebar-text-hover focus-visible:ring-sidebar-text-selected/30 flex min-w-0 items-center overflow-hidden rounded-md text-sm outline-none transition-colors focus-visible:ring-2',
    isSub ? 'h-7 -translate-x-px gap-2 px-2' : 'h-8 gap-2 px-2 font-medium',
    minimized && !isSub && 'mx-auto w-8 justify-center px-0',
    className,
    {
      'text-sidebar-text': !current,
      'bg-sidebar-text-selected/10 text-sidebar-text-selected-foreground font-medium': current,
    },
  );

  const displayLabel = (() => {
    if (minimized && !isSub) {
      return '';
    }

    return label;
  })();

  return (
    <Link
      to={href || ''}
      onClick={() => onClick(href || '')}
      className={style}
      aria-current={current ? 'page' : undefined}
    >
      {Icon && <Icon className={cn('h-4 w-4 shrink-0', isSub && 'h-3.5 w-3.5')} />}
      {displayLabel && <span className="min-w-0 truncate">{displayLabel}</span>}
    </Link>
  );
};
